<template>

    <Rw_HomeView></Rw_HomeView>

    <div class="task_bee" id="bee_task" style="display: none;">
        <Task_HomeView ></Task_HomeView>
    </div>

    <div class="bee_nInvite" id="bee_nInvite">
        <Invite_HomeView ></Invite_HomeView>
    </div>

  </template>
  
  <script>
  import Rw_HomeView from './components/Home.vue'
  import Task_HomeView from './view/Home.vue'
  import Invite_HomeView from './components/invite/Home.vue'
  export default {
    name: 'Main',
    components: {
        Rw_HomeView,
        Task_HomeView,
        Invite_HomeView
    }
  }
  
  
  </script>
  
  <style scoped>
 .task_bee {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 64;
  right: 0;
  padding: 12px;
  z-index: 2000;
  transition: transform 700ms;
  background: rgba(0, 0, 0, 0.60);
  border: none;
  flex-direction: column;
  justify-content: center;
  height: 100vh;
  align-items: center;
  display: none
}

.bee_nInvite {
  background-color: #fff;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 2100;
  transition: transform 700ms;
  border: none;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: -webkit-fill-available;
  width: -moz-available;
  display: none
}
  </style>
  